
<template>
    
        <mars-view v-if="answer" class="lawyer-card-container" @click.native="goDetail"><mars-view v-if="showInfo.imgUrl" class="avatar-box"><mars-image class="avatar" :src="showInfo.imgUrl"></mars-image></mars-view><mars-view class="main-info-box"><mars-view class="name lineclamp1">{{ showInfo.name }}</mars-view><mars-view class="info lineclamp1"><mars-text class="law-firm">全面，专业，智能的法律检索平台</mars-text></mars-view></mars-view></mars-view>
    
</template>

<script>
import log from '../../../static/utils/ubcLog';
import { act } from '../../../static/utils/navigate';
export default {
  props: {
    // 答主信息
    answer: {
      type: Object,
      default() {
        return {};
      }
    },
    // 跳转链接
    jumpUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 律师信息
    showInfo() {
      return this.answer && this.answer.user && this.answer.user.showInfo || {};
    }
  },
  methods: {
    // 跳转详细信息页面
    goDetail() {
      if (!this.jumpUrl) {
        return;
      }
      log.send && log.send({
        serverId: 17017,
        area: 'bdfb-passid',
        action: 'click'
      });
      act({
        target: this.jumpUrl,
        type: 'webview'
      });
    }
  }
};
</script>

<style scoped>
.lawyer-card-container {
  display: flex;
  align-items: center;
  padding-top: 7.25vw;
}
.lawyer-card-container .lineclamp1 {
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.lawyer-card-container .avatar-box {
  flex-shrink: 0;
}
.lawyer-card-container .avatar-box .avatar {
  display: block;
  width: 9.66vw;
  height: 9.66vw;
  border: 0.16vw solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  border-radius: 50%;
}
.lawyer-card-container .main-info-box {
  flex: 1;
  margin-left: 2.42vw;
}
.lawyer-card-container .main-info-box .name {
  font-family: PingFang SC;
  font-size: 4.11vw;
  color: #1e1f24;
  line-height: 4.91vw;
  font-weight: 700;
}
.lawyer-card-container .main-info-box .info {
  margin-top: 0.72vw;
  font-family: PingFang SC;
  font-size: 3.38vw;
  color: #848691;
  line-height: 3.86vw;
}
.lawyer-card-container .main-info-box .info .law-firm {
  vertical-align: midd;
}

</style>
